// The contributor's own validation contracts (to sign, signed, awaiting the
// moderator's final validation).
import { useMemo, useState } from "react";
import { contractsApi } from "@/api/contracts.api";
import { canAccessContributorWorkspace } from "@/lib/auth/roles";
import { ContractStatus } from "@/lib/types/contracts";
import { latestValidationContract } from "../logic/moderation-logic";
import type { GetPaidUser } from "./get-paid-context";

export function useUserContracts(user: GetPaidUser) {
  const [userContracts, setUserContracts] = useState<any[]>([]);
  const [loadingUserContracts, setLoadingUserContracts] = useState(false);

  const latestPendingUserContract = useMemo(
    () => latestValidationContract(userContracts, [ContractStatus.SENT, ContractStatus.VIEWED]),
    [userContracts],
  );
  const latestSignedUserContract = useMemo(
    () => latestValidationContract(userContracts, [ContractStatus.SIGNED, ContractStatus.FINAL_VALIDATED]),
    [userContracts],
  );
  const latestAwaitingFinalUserContract = useMemo(
    () => latestValidationContract(userContracts, [ContractStatus.SIGNED]),
    [userContracts],
  );

  const loadUserContracts = async () => {
    if (!user?.id || !canAccessContributorWorkspace(user.role)) {
      return;
    }
    setLoadingUserContracts(true);
    try {
      const contracts = await contractsApi.getMyContracts();
      setUserContracts(Array.isArray(contracts) ? contracts : []);
    } catch {
      setUserContracts([]);
    } finally {
      setLoadingUserContracts(false);
    }
  };

  return {
    userContracts, loadingUserContracts, loadUserContracts,
    latestPendingUserContract, latestSignedUserContract, latestAwaitingFinalUserContract,
  };
}
